/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import { React, PT, WithData, fetchApi } from '@gasbuddy/react';
import DatePicker from 'react-datepicker';
import TimePicker from 'rc-time-picker';
import JSONTree from 'react-json-tree';
import { Dimmer, Loader, Segment, Form, Divider, Modal, Grid } from 'semantic-ui-react';
import { toFunction } from 'async-rule-evaluator';
import { Auth, Nav } from '../../components';
import { fetch } from '../../../client/lib/fetch';
import { AddFeatureVariant } from './AddFeatureVariant';

class BaseVariant extends React.Component {
  state = {
    email: '',
    anon: '',
    overwrite: true,
    createAccounts: true,
  }

  saveEligibility = async (e) => {
    e.preventDefault();
    const { eligibility } = this.state;
    try {
      if (eligibility.trim()) {
        toFunction(eligibility);
      }
    } catch (error) {
      this.setState({ error: `The filter expression is invalid: ${error.message}` });
      return;
    }
    const { data: { variant: { feature_variant_id: fvid } }, fetch: fetchFn } = this.props;
    this.setState({ assigning: true, error: null }, async () => {
      const { status, body, error } = await fetchApi({
        url: `/system/features/variant/eligibility/${fvid}`,
        body: { eligibility },
        catchErrors: true,
      });
      if (status !== 200) {
        this.setState({ assigning: false, error: error ? error.toString() : body });
      } else {
        this.setState({
          assigning: false,
        });
        fetchFn();
      }
    });
  }

  clear(f) {
    return (e) => {
      e.preventDefault();
      this.setState({
        [`${f}Date`]: null,
        [`${f}Time`]: null,
      });
    };
  }

  submitAssignments(e) {
    e.preventDefault();
    const { data: { variant } } = this.props;
    const { email, anon, overwrite, createAccounts, fromDate, fromTime, toDate, toTime } = this.state;
    this.setState({ assigning: true }, async () => {
      try {
        const { body } = await fetch(`/system/features/variant/${variant.feature_variant_id}/assignments`, {
          begins: fromDate ? `${fromDate.format('YYYY-MM-DD')}T${fromTime.format('HH:mm:ss')}Z` : null,
          expires: toDate ? `${toDate.format('YYYY-MM-DD')}T${toTime.format('HH:mm:ss')}Z` : null,
          emails: email,
          anonymousIds: anon,
          overwrite,
          createAccounts,
        });
        this.setState({
          assigning: false,
          lastSave: body,
          anon: '',
          email: body.emailsNotFound ? body.emailsNotFound.join('\n') : '',
        });
      } catch (error) {
        this.setState({ error, assigning: false });
      }
    });
  }

  render() {
    const { data, loading, fetch: fetchFn } = this.props;
    const hasEditedEligibility = 'eligibility' in this.state;
    const { assigning, error, lastSave, email, anon, createAccounts, overwrite, fromDate, fromTime, toDate, toTime, eligibility } = this.state;
    const { variant = {} } = data || {};

    return (
      <Auth forRoles="admin.superuser,admin.system.features">
        <Nav>
          <Dimmer.Dimmable as={Segment} dimmed={loading || assigning}>
            <Dimmer active={loading || assigning}>
              <Loader />
            </Dimmer>
            <Modal open={!!error} closeIcon onClose={() => this.setState({ error: null })}>
              <Modal.Header>Oops... An error has occurred</Modal.Header>
              <Modal.Content><pre>{error ? error.stack : ''}</pre></Modal.Content>
            </Modal>
            <Grid columns="equal">
              <Grid.Row>
                <Grid.Column>
                  <h1>{variant.name}</h1>
                  <b>Feature</b>
:
                  {variant.feature_name}
                  {' '}
(
                  {variant.internal_name}
)
                  <br />
                </Grid.Column>
                <Grid.Column width="3">
                  {variant && variant.feature_variant_id
                    && (
                    <AddFeatureVariant
                      buttonLabel="Edit Variant"
                      buttonIcon="edit"
                      featureId={variant.feature_id}
                      ignorePoints={variant.ignore_points}
                      fetch={fetchFn}
                      defaultValue={variant}
                    />
                    )
                  }
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Divider />
            {variant.payload
              && (
              <div>
                <h2>Payload</h2>
                <JSONTree data={variant.payload} />
              </div>
              )
            }
            <h2>Variant Eligibility</h2>
            {variant.ios_semver !== null ? (
              <div>
                <b>iOS SemVer Requirement:</b>
                &nbsp;
                {variant.ios_semver}
              </div>
            ) : null}
            {variant.android_semver !== null ? (
              <div>
                <b>Android SemVer Requirement:</b>
                &nbsp;
                {variant.android_semver}
              </div>
            ) : null}
            {variant.other_semver !== null ? (
              <div>
                <b>Non-iOS/Android SemVer Requirement:</b>
                &nbsp;
                {variant.other_semver}
              </div>
            ) : null}
            <Form>
              <Form.Group widths="equal">
                <Form.TextArea
                  fluid
                  rows={3}
                  value={hasEditedEligibility ? eligibility : variant.variant_eligibility_rule}
                  onChange={e => this.setState({ eligibility: e.target.value })}
                />
                <Form.Button onClick={this.saveEligibility}>Save Eligibility</Form.Button>
              </Form.Group>
            </Form>
            <Divider />
            <h2>Manual Assignment</h2>
            <p>Enter a list of identifiers to manually assign them to this variant</p>
            <Form onSubmit={e => this.submitAssignments(e)}>
              <Form.Group widths="equal">
                <Form.TextArea
                  rows={15}
                  value={email}
                  onChange={e => this.setState({ email: e.target.value })}
                  label="Email Addresses / Account Ids"
                  placeholder="Enter one email address or numeric account id per line..."
                />
                <Form.TextArea
                  rows={15}
                  value={anon}
                  onChange={e => this.setState({ anon: e.target.value })}
                  label="Anonymous Identifiers"
                  placeholder="Enter one anonymous identifier per line..."
                />
              </Form.Group>
              <Form.Checkbox
                checked={overwrite}
                onChange={(e, { checked }) => this.setState({ overwrite: checked })}
                label="Overwrite/Move existing assignments"
              />
              <Form.Checkbox
                checked={createAccounts}
                onChange={(e, { checked }) => this.setState({ createAccounts: checked })}
                label="Create identity accounts for unknown emails"
              />
              <Form.Group width="equal">
                <Form.Field>
                  <label htmlFor="fromDate">Begins At</label>
                  <DatePicker
                    id="fromDate"
                    className="datetime"
                    selected={fromDate}
                    onChange={v => this.setState({ fromDate: v })}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="fromTime">(@ UTC time)</label>
                  <TimePicker
                    id="fromTime"
                    className="datetime"
                    value={fromTime}
                    onChange={v => this.setState({ fromTime: v })}
                  />
                </Form.Field>
                <Form.Button label="&nbsp;" onClick={this.clear('from')}>Clear</Form.Button>
                <Form.Field>
                  <label htmlFor="toDate">Expires After</label>
                  <DatePicker
                    id="toDate"
                    className="datetime"
                    selected={toDate}
                    onChange={v => this.setState({ toDate: v })}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="toTime">(@ UTC time)</label>
                  <TimePicker
                    id="toTime"
                    className="datetime"
                    value={toTime}
                    onChange={v => this.setState({ toTime: v })}
                  />
                </Form.Field>
                <Form.Button label="&nbsp;" onClick={this.clear('to')}>Clear</Form.Button>
              </Form.Group>
              <Form.Button>Assign</Form.Button>
              {lastSave
                && (
                <span>
                  Saved
                  {' '}
                  <b>{lastSave.emailAdds}</b>
                  {' '}
account assignment(s) and&nbsp;
                  <b>{lastSave.anonymousAdds}</b>
                  {' '}
anonymous assignment(s).
                  {lastSave.emailsNotFound && lastSave.emailsNotFound.length
                    && (
                    <span>
                      <b>{lastSave.emailsNotFound.length}</b>
                      {' '}
email(s) did
                    not have matching accounts.
                    </span>
                    )
                  }
                </span>
                )
              }
            </Form>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

BaseVariant.propTypes = {
  fetch: PT.func.isRequired,
  data: PT.shape({
    variant: PT.shape({
      name: PT.string,
    }),
  }),
  loading: PT.bool,
};

BaseVariant.defaultProps = { loading: false, data: null };

export const Variant = ({ match }) => (
  <WithData url={`/system/features/variant/${match.params.variantId}`}>
    <BaseVariant />
  </WithData>
);

Variant.propTypes = {
  match: PT.shape({
    params: PT.shape({
      variantId: PT.string.isRequired,
    }).isRequired,
  }).isRequired,
};
